<script setup lang="tsx">
import { getCSSVar } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {
    color: getCSSVar("--xg-blue")
  }
);
</script>

<template>
  <div class="loading-10">
    <svg viewBox="0 0 50 50">
      <circle
        class="ring"
        cx="25"
        cy="25"
        r="20"
        :style="['stroke: rgba(0,0,0,0.1)']"
      ></circle>
      <circle
        class="ball"
        cx="25"
        cy="5"
        r="3.5"
        :style="['fill: ' + props.color]"
      ></circle>
    </svg>
  </div>
</template>

<style scoped>
.loading-10 {
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.loading-10 svg {
  width: 50%;
  aspect-ratio: 1 / 1;
  transform-origin: center;
  animation: 1.5s spin ease infinite;
}
.ring {
  fill: none;
  stroke-width: 2;
}

.ball {
  stroke: none;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
